import { LocaleSelect, localeOptions } from 'components/Form/LocaleSelect'
import { useMemo } from 'react'
import { AdvancedInputProps, BasicInputGroup } from '.'

export interface LocaleInputProps extends AdvancedInputProps {
  value?: string
}

export const LocaleInput = ({
  value,
  label,
  name,
  disabled,
  setFieldValue,
  onBlur,
  error,
  tabIndex,
}: LocaleInputProps) => {
  const selected = useMemo(
    () => localeOptions.find((o) => o.value === value),
    [value]
  )
  const displayText = selected?.label || '-'

  return (
    <BasicInputGroup
      name={name}
      label={label}
      error={error}
      disabled={disabled}
      display={displayText}
      input={
        <LocaleSelect
          data-cy="locale"
          name={name}
          value={value}
          hasErrors={!!error}
          disabled={disabled}
          onChange={(locale) => {
            setFieldValue(name, locale.value)
          }}
          onBlur={onBlur}
          tabIndex={tabIndex}
        />
      }
    />
  )
}
